// src/utils/firebase.ts
// Centralized Firebase initialization for the NatureDr app

import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const initAnalytics = (): Analytics | null => {
  try {
    return getAnalytics(app);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Firebase Analytics failed to initialize:', e);
    return null;
  }
};

const analytics = initAnalytics();

export { app, analytics };
